function NoExpense() {
  return (
    <div className="no-expense">
      <h2>No expense found</h2>
    </div>
  );
}

export default NoExpense;
